import {inject} from 'aurelia-framework';  
import {Router} from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import { SiteParameterAPI } from '../../services/admin/siteParameterAPI';

@inject(AuthService, Router, SiteParameterAPI, UserMessageService)
export class SiteParameters {
    constructor(authService, router, api, userMessageService) {
        
        this.authService = authService;
        this.router = router;
        this.api = api;
        this.userMessageService = userMessageService;
        
        this.saving = false;
    }

    activate(params) {
        this.loading = true;
       

        this.load();        
    }

    load() {
        this.api.getList(
            this.authService.getUser().token, 
            this.saveLoadSuccess.bind(this), 
            this.saveLoadError.bind(this));
    }
  
    save() {
        
        this.saving = true;
        this.api.save(
            this.parameters, 
            this.authService.getUser().token, 
            this.saveLoadSuccess.bind(this), 
            this.saveLoadError.bind(this));
        
    }

    saveLoadSuccess(data) {
        this.loading = false;
        this.parameters = data;
       
        if(this.saving)
            this.userMessageService.setUserMessage("user", "Saved!");
        this.saving = false;
    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
        this.loading = false;
        
    }

    itemChanged(item) {
        item.changed = true;
    }

    
    
    
}